// Copyright text placeholder, Warner Bros. Discovery, Inc.

/**
 *  WARNING:
 *  This file is auto-generated. Do not edit manually. Any changes made to this
 *  file will be overwritten the next time it is generated. If you need to make
 *  changes, please modify the source files and re-generate this file.
 */

import { BaseEvent, IVersionedEvent } from '../../../core';

/**
 * The name of the mark. This is protected by a screaming snake case ENUM so that all clients are required to use the same mark names, and to limit typos in telemetry. NOTE: Marks that are used as the start/end of measures should follow a general convention of [measureName]_START and [measureName]_END.
 * @public
 * @readonly
 */

enum NameV1 {
  /** Name of BOOT_START **/
  BOOT_START = 'BOOT_START',
  /** Name of BOOT_END **/
  BOOT_END = 'BOOT_END',
  /** Name of PAGE_ROUTE_CHANGED **/
  PAGE_ROUTE_CHANGED = 'PAGE_ROUTE_CHANGED',
  /** Name of SPLASH_SCREEN_REMOVED **/
  SPLASH_SCREEN_REMOVED = 'SPLASH_SCREEN_REMOVED',
  /** Name of PAGE_DATA_LOAD_START **/
  PAGE_DATA_LOAD_START = 'PAGE_DATA_LOAD_START',
  /** Name of PAGE_DATA_LOAD_END **/
  PAGE_DATA_LOAD_END = 'PAGE_DATA_LOAD_END'
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IPageV1 {
  /** The relative url of the page. **/
  uri: string;
  /** Canonical pageId of the currently rendered page. Canonical pageIds must be consistent across all implementations of Beam; we achieve this by using CMS-provided values where possible. **/
  id?: string;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IMarkV1Payload {
  /** The name of the mark. This is protected by a screaming snake case ENUM so that all clients are required to use the same mark names, and to limit typos in telemetry. NOTE: Marks that are used as the start/end of measures should follow a general convention of [measureName]_START and [measureName]_END. **/
  name: NameV1;
  /**  **/
  page: IPageV1;
}

/**
 * PerformanceMarkV1 event
 * An event emitted by the client denoting when a performance lifecycle event has occurred.
 * @public
 */
export class PerformanceMarkV1 extends BaseEvent<IMarkV1Payload> {
  /** unique event type **/
  public readonly eventType: string = 'beam.events.performance.mark_1.0';
  /** The name of the mark. This is protected by a screaming snake case ENUM so that all clients are required to use the same mark names, and to limit typos in telemetry. NOTE: Marks that are used as the start/end of measures should follow a general convention of [measureName]_START and [measureName]_END. **/
  public static NAME: typeof NameV1 = NameV1;

  /**
   * overrides the default _build method to add default values for fields
   * @param payload - The payload for this event.
   * @returns IVersionedEvent<IMarkV1Payload>
   */
  protected override _build(payload: IMarkV1Payload): IVersionedEvent<IMarkV1Payload> {
    return super._build({
      ...payload
    });
  }
}

export { NameV1 as PerformanceMarkV1Name };
export type { IPageV1 as IPerformanceMarkV1Page };
export type { IMarkV1Payload as IPerformanceMarkV1Payload };
